import { invariant } from '@vp/digital-invariant-lib';
import React, { useState, useEffect } from 'react';
import { none, some, isNone, isSome } from 'fp-ts/lib/Option';
import { Helmet } from 'react-helmet';
import { useLocale } from '@vp/digital-locale-lib';
import { getClientEnvironment, Environment } from '@vp/digital-environment-lib';
import { getLibraryLoggingAttributes, getLogger, Dispenser } from '@vp/digital-logging-lib';
import { Box, Typography, FlexBox, Spinner } from '@vp/swan';
import { SERVICE_LENGTH_ATTRIBUTE_NAME, getServiceLength } from '@vp/digital-product-lib';
import { makeUseAxios } from 'axios-hooks';
import { RetryPolicy, HttpClientDispenser } from '@vp/digital-http-client-lib';
import { TokenReplacer } from '@vp/digital-token-replacer-lib';

function unwrapExports (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var cdn = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.latestPricingContextModuleUrl = exports["default"] = void 0;
var latestPricingContextModuleUrl = exports.latestPricingContextModuleUrl = "https://pricing-context-module.products.vpsvc.com/static/v3/pricing-context-module.min.js";

exports["default"] = {
  latestPricingContextModuleUrl: latestPricingContextModuleUrl
};
});

unwrapExports(cdn);
var cdn_1 = cdn.latestPricingContextModuleUrl;

var helpers = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initializePricingContext = exports.getPcxtV3 = exports.executeAfterPricingContextEvent = exports["default"] = exports.QUERY_PARAMETERS = exports.EVENTS = exports.COOKIE_DATA = void 0;
// If updated, please REMEMBER to update the mirroring constants in pricing-context-module.js
var COOKIE_NAME = 'PCXT';
var COOKIE_REGEX = new RegExp("(^| )".concat(COOKIE_NAME, "=([^;]+)"));
var SCRIPT_LOADED_EVENT = 'PCXT-V3-ScriptLoaded';
var INITIALIZED_EVENT = 'PCXT-V3-ModuleInitialized';
var CONTEXT_CHANGE_EVENT = 'PCXT-V3-ContextChanged';
var COUPON_CHANGE_EVENT = 'PCXT-V3-CouponCodeChanged';
var VAT_INCLUSIVITY_CHANGE_EVENT = 'PCXT-V3-VatInclusivityChanged';
var DATE_TIME_CHANGE_EVENT = 'PCXT-V3-EffectiveDateTimeChanged';
var VAT_INCLUSIVITY_QUERY_PARAMETER = 'PCXTVATINCLUSIVE';
var DATE_TIME_QUERY_PARAMETER = 'PCXTEFFECTIVEDATETIME';

var windowAndDocumentExist = function windowAndDocumentExist() {
  return typeof window !== 'undefined' && window.document;
};

var COOKIE_DATA = exports.COOKIE_DATA = {
  COOKIE_NAME: COOKIE_NAME,
  COOKIE_REGEX: COOKIE_REGEX
};
var EVENTS = exports.EVENTS = {
  SCRIPT_LOADED_EVENT: SCRIPT_LOADED_EVENT,
  INITIALIZED_EVENT: INITIALIZED_EVENT,
  CONTEXT_CHANGE_EVENT: CONTEXT_CHANGE_EVENT,
  COUPON_CHANGE_EVENT: COUPON_CHANGE_EVENT,
  VAT_INCLUSIVITY_CHANGE_EVENT: VAT_INCLUSIVITY_CHANGE_EVENT,
  DATE_TIME_CHANGE_EVENT: DATE_TIME_CHANGE_EVENT
};
var QUERY_PARAMETERS = exports.QUERY_PARAMETERS = {
  VAT_INCLUSIVITY_QUERY_PARAMETER: VAT_INCLUSIVITY_QUERY_PARAMETER,
  DATE_TIME_QUERY_PARAMETER: DATE_TIME_QUERY_PARAMETER
};

var ignore = function ignore() {};

var registerCustomInitCallback = function registerCustomInitCallback(configuration, callback) {
  if (typeof callback !== 'function') {
    return;
  }

  if (window.document.pcxtV3 && window.document.pcxtV3.isInitialized(configuration.merchantId, configuration.market, configuration.isDevelopmentMode)) {
    callback(window.document.pcxtV3.getPricingContext());
  } else {
    window.document.addEventListener(INITIALIZED_EVENT, function onInit(e) {
      window.document.removeEventListener(INITIALIZED_EVENT, onInit, false);
      callback(e.detail);
    });
  }
};

var callPCMInit = function callPCMInit(configuration) {
  window.document.pcxtV3.init(configuration.merchantId, configuration.market, configuration.isDevelopmentMode)["catch"](ignore);
};

var initializePricingContext = exports.initializePricingContext = function initializePricingContext(configuration, callback) {
  if (!windowAndDocumentExist()) {
    return;
  }

  registerCustomInitCallback(configuration, callback);

  if (window.document.pcxtV3) {
    callPCMInit(configuration);
  } else {
    window.document.addEventListener(SCRIPT_LOADED_EVENT, function callback() {
      window.document.removeEventListener(SCRIPT_LOADED_EVENT, callback, false);
      callPCMInit(configuration);
    });
  }
};

var executeAfterPricingContextEvent = exports.executeAfterPricingContextEvent = function executeAfterPricingContextEvent(event, callback, continueListening) {
  if (typeof callback !== 'function') {
    return;
  }

  if (Object.values(EVENTS).indexOf(event) === -1) {
    console.warn("Event '".concat(event, "' is NOT a valid pricing context event."));
    return;
  }

  if (!windowAndDocumentExist()) {
    return;
  }

  window.document.addEventListener(event, function onEvent(e) {
    if (!continueListening) {
      window.document.removeEventListener(event, onEvent, false);
    }

    callback(e.detail);
  });
};

var getPcxtV3 = exports.getPcxtV3 = function getPcxtV3() {
  if (!windowAndDocumentExist()) {
    return undefined;
  }

  return window.document.pcxtV3;
};

exports["default"] = {
  COOKIE_DATA: COOKIE_DATA,
  EVENTS: EVENTS,
  QUERY_PARAMETERS: QUERY_PARAMETERS,
  initializePricingContext: initializePricingContext,
  executeAfterPricingContextEvent: executeAfterPricingContextEvent,
  getPcxtV3: getPcxtV3
};
});

unwrapExports(helpers);
var helpers_1 = helpers.initializePricingContext;
helpers.getPcxtV3;
var helpers_3 = helpers.executeAfterPricingContextEvent;
helpers.QUERY_PARAMETERS;
var helpers_5 = helpers.EVENTS;
helpers.COOKIE_DATA;

var vatCountries = [
    { country: 'Austria', countryCode: 'AT' },
    { country: 'Belgium', countryCode: 'BE' },
    { country: 'Bulgaria', countryCode: 'BG' },
    { country: 'Switzerland', countryCode: 'CH' },
    { country: 'Cyprus', countryCode: 'CY' },
    { country: 'Czech Republic', countryCode: 'CZ' },
    { country: 'Germany', countryCode: 'DE' },
    { country: 'Denmark', countryCode: 'DK' },
    { country: 'Estonia', countryCode: 'EE' },
    { country: 'Spain', countryCode: 'ES' },
    { country: 'Finland', countryCode: 'FI' },
    { country: 'France', countryCode: 'FR' },
    { country: 'Greece', countryCode: 'GR' },
    { country: 'Croatia (Hrvatska)', countryCode: 'HR' },
    { country: 'Hungary', countryCode: 'HU' },
    { country: 'Ireland', countryCode: 'IE' },
    { country: 'Italy', countryCode: 'IT' },
    { country: 'Japan', countryCode: 'JP' },
    { country: 'Liechtenstein', countryCode: 'LI' },
    { country: 'Lithuania', countryCode: 'LT' },
    { country: 'Luxembourg', countryCode: 'LU' },
    { country: 'Latvia', countryCode: 'LV' },
    { country: 'Monaco', countryCode: 'MC' },
    { country: 'Malta', countryCode: 'MT' },
    { country: 'Netherlands', countryCode: 'NL' },
    { country: 'Norway', countryCode: 'NO' },
    { country: 'New Zealand', countryCode: 'NZ' },
    { country: 'Poland', countryCode: 'PL' },
    { country: 'Portugal', countryCode: 'PT' },
    { country: 'Romania', countryCode: 'RO' },
    { country: 'Sweden', countryCode: 'SE' },
    { country: 'Slovenia', countryCode: 'SI' },
    { country: 'Slovakia', countryCode: 'SK' },
    { country: 'United Kingdom', countryCode: 'GB' },
    { country: 'United Kingdom', countryCode: 'UK' },
    { country: 'South Africa', countryCode: 'ZA' },
];

function getIsVatSupported(currentCountryCode) {
    return vatCountries.some(function (_a) {
        var countryCode = _a.countryCode;
        return countryCode.toUpperCase() === currentCountryCode;
    });
}

var name = "@vp/digital-pricing-lib";
var version = "0.20.10";

var getLibLogger = function (attributes) {
    var attr = getLibraryLoggingAttributes(name, version, attributes);
    return getLogger(attr);
};

var DEFAULT_MERCHANT_ID = 'VISTAPRINT';
var windowAndDocumentExist = function () {
    return typeof window !== 'undefined' && window.document;
};
var getPricingContextModuleV3 = function () {
    return windowAndDocumentExist() && window.document.pcxtV3;
};
var PricingContextContext = React.createContext(undefined);
function PricingContextProvider(_a) {
    var _b = _a.merchantId, merchantId = _b === void 0 ? DEFAULT_MERCHANT_ID : _b, children = _a.children;
    var countryCode = useLocale().countryCode;
    var _c = useState(none), pricingContext = _c[0], setPricingContext = _c[1];
    var isNonProdEnv = getClientEnvironment() !== Environment.Prod;
    useEffect(function () {
        var pricingContextConfig = {
            merchantId: merchantId,
            market: countryCode,
            isDevelopmentMode: isNonProdEnv,
        };
        var logger = getLibLogger();
        var updatePricingContext = function () {
            var pricingContextModule = getPricingContextModuleV3();
            invariant(pricingContextModule, 'pricing Context Module does not exist on document');
            var newPricingContext = {
                contextAsQueryString: pricingContextModule.getContextAsQueryString(),
                encodedContextString: pricingContextModule.getEncodedContextString(),
                isVatInclusive: pricingContextModule.isVatInclusive(),
                isVatSupported: getIsVatSupported(countryCode),
            };
            logger.debug('Updating Pricing Context', newPricingContext);
            setPricingContext(some(newPricingContext));
        };
        logger.debug('Initializing Pricing Context Module', pricingContextConfig);
        helpers_1(pricingContextConfig, updatePricingContext);
        helpers_3(helpers_5.CONTEXT_CHANGE_EVENT, updatePricingContext, true);
    }, [countryCode, isNonProdEnv, merchantId]);
    return (React.createElement(PricingContextContext.Provider, { value: pricingContext },
        React.createElement(Helmet, null,
            React.createElement("script", { defer: true, src: cdn_1, type: "text/javascript" })),
        children));
}
function usePricingContext() {
    var context = React.useContext(PricingContextContext);
    invariant(context, 'usePricingContext must be used within a PricingContextProvider');
    return context;
}

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol, Iterator */


var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

var contentfulMapper = function (billingPeriodData) {
    return billingPeriodData.map(function (billingPeriod) {
        var _a;
        return ({
            serviceLengthAttributeKey: billingPeriod.node.billingPeriodAttribute.mcpAttribute.value,
            billingPeriodDisclaimerText: billingPeriod.node.billingPeriodDisclaimerText,
            billingPeriodText: billingPeriod.node.periodText,
            perPeriodText: billingPeriod.node.perPeriodText,
            monthsInPeriod: billingPeriod.node.monthsInPeriod,
            promotionalPricingDisclaimerSymbol: billingPeriod.node.promotionalPricingDisclaimerSymbol,
            promotionalPricingDisclaimerText: billingPeriod.node.promotionalPricingDisclaimerText,
            promotionalPricingDisclaimerDescription: (_a = billingPeriod.node.promotionalPricingDisclaimerDescription) === null || _a === void 0 ? void 0 : _a.promotionalPricingDisclaimerDescription,
            vatExclusiveText: billingPeriod.node.vatExclusiveText,
            vatInclusiveText: billingPeriod.node.vatInclusiveText,
            billingPeriodAttribute: billingPeriod.node.billingPeriodAttribute.mcpAttribute,
            freePricingDisclaimerText: billingPeriod.node.freePricingDisclaimerText,
        });
    });
};

var BillingPeriodKeys = {
    Tower: 'tower',
    WixBillingCycle: 'wixBillingCycle',
    WixPlansGrid: 'wixPlansGrid',
    WixNewPlansGrid: 'wixNewPlansGrid',
    WixDomainsRegistrationPeriod: 'wixDomainsRegistrationPeriod',
};
function getLocaleBillingPeriodsContentful(graphql, locale, key) {
    return __awaiter(this, void 0, void 0, function () {
        var query, params, result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    query = "\nquery getLocaleBillingPeriods($locale:String!, $key:String) {\n  allContentfulBillingPeriod(filter: {node_locale: {eq: $locale}, key: {eq: $key}}) {\n    edges {\n      node {\n        node_locale\n        key\n        contentfulName\n        billingPeriodDisclaimerText\n        billingPeriodAttribute {\n          keyDisplayName\n          valueDisplayName\n          contentfulName\n          mcpAttribute {\n            name\n            value\n          }\n        }\n        monthsInPeriod\n        perPeriodText\n        periodText\n        promotionalPricingDisclaimerSymbol\n        promotionalPricingDisclaimerText\n        promotionalPricingDisclaimerDescription {\n          promotionalPricingDisclaimerDescription\n        }\n        vatExclusiveText\n        vatInclusiveText\n        freePricingDisclaimerText\n      }\n    }\n  }\n}";
                    params = { locale: locale, key: key };
                    return [4, graphql(query, params)];
                case 1:
                    result = _a.sent();
                    return [2, result];
            }
        });
    });
}
function getLocaleBillingPeriods(graphql, locale, key) {
    return __awaiter(this, void 0, void 0, function () {
        var result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4, getLocaleBillingPeriodsContentful(graphql, locale, key)];
                case 1:
                    result = _a.sent();
                    if (result.errors) {
                        return [2, Promise.reject(result.errors)];
                    }
                    return [2, contentfulMapper(result.data.allContentfulBillingPeriod.edges)];
            }
        });
    });
}

var classnames = createCommonjsModule(function (module) {
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
/* global define */

(function () {

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = '';

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (arg) {
				classes = appendClass(classes, parseValue(arg));
			}
		}

		return classes;
	}

	function parseValue (arg) {
		if (typeof arg === 'string' || typeof arg === 'number') {
			return arg;
		}

		if (typeof arg !== 'object') {
			return '';
		}

		if (Array.isArray(arg)) {
			return classNames.apply(null, arg);
		}

		if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
			return arg.toString();
		}

		var classes = '';

		for (var key in arg) {
			if (hasOwn.call(arg, key) && arg[key]) {
				classes = appendClass(classes, key);
			}
		}

		return classes;
	}

	function appendClass (value, newClass) {
		if (!newClass) {
			return value;
		}
	
		if (value) {
			return value + ' ' + newClass;
		}
	
		return value + newClass;
	}

	if (module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else {
		window.classNames = classNames;
	}
}());
});

var isWholeNumber = function (num) { return num % 1 === 0; };
var getPriceFormat = function (culture, currency, minimumFractionDigits, price) {
    var numDigits = isWholeNumber(price) ? 0 : minimumFractionDigits;
    return new Intl.NumberFormat(culture, {
        style: 'currency',
        currency: currency,
        maximumFractionDigits: numDigits,
        minimumFractionDigits: numDigits,
    });
};
var formatPrice = function (culture, currency, minimumFractionDigits, price) {
    return getPriceFormat(culture, currency, minimumFractionDigits, price).format(price);
};
var getPricePerDisplayPeriod = function (displayPeriod, period, price) {
    var factor = displayPeriod.monthsInPeriod / period.monthsInPeriod;
    return price * factor;
};
var useDisplayPrice = function (price, displayPeriodContent, pricePeriodContent, pricingContext, overrideSales) {
    if (!price || !pricingContext) {
        return {};
    }
    var rawPrice = pricingContext.isVatInclusive
        ? price.taxed
        : price.untaxed;
    var displayListPrice = getPricePerDisplayPeriod(displayPeriodContent, pricePeriodContent, rawPrice.listPrice);
    var formattedListPrice = formatPrice(price.culture, price.currency, price.minimumFractionDigits, displayListPrice);
    var formattedListPriceParts = getPriceFormat(price.culture, price.currency, price.minimumFractionDigits, displayListPrice).formatToParts(displayListPrice);
    var displayDiscountPrice = getPricePerDisplayPeriod(displayPeriodContent, pricePeriodContent, rawPrice.discountPrice);
    var formattedDiscountPrice = formatPrice(price.culture, price.currency, price.minimumFractionDigits, displayDiscountPrice);
    var formattedDiscountPriceParts = getPriceFormat(price.culture, price.currency, price.minimumFractionDigits, displayDiscountPrice).formatToParts(displayDiscountPrice);
    var isDiscounted = displayListPrice > displayDiscountPrice || overrideSales;
    var isFree = displayListPrice === 0 || displayDiscountPrice === 0;
    return {
        isFree: isFree,
        displayListPrice: displayListPrice,
        formattedListPrice: formattedListPrice,
        formattedListPriceParts: formattedListPriceParts,
        isDiscounted: isDiscounted,
        displayDiscountPrice: displayDiscountPrice,
        formattedDiscountPrice: formattedDiscountPrice,
        formattedDiscountPriceParts: formattedDiscountPriceParts,
    };
};

var PricingContentContext = React.createContext(undefined);
var NO_BILLING_PERIOD_DISCLAIMER_TEXT = '';
function getPeriod(periods, periodKey) {
    invariant(periodKey, 'The period key is required');
    var period = periods.find(function (period) {
        return period.serviceLengthAttributeKey === periodKey;
    });
    invariant(period, "No period content for key: ".concat(periodKey));
    return period;
}
function getBillingPeriodContent(periods, pricePeriodKey, displayPeriodKey) {
    invariant(periods, 'The periods array is required');
    var pricePeriod = getPeriod(periods, pricePeriodKey);
    var displayPeriod = getPeriod(periods, displayPeriodKey);
    var billingPeriodDisclaimerText = displayPeriodKey === pricePeriodKey
        ? NO_BILLING_PERIOD_DISCLAIMER_TEXT
        : pricePeriod.billingPeriodDisclaimerText;
    return {
        serviceLengthAttributeKey: pricePeriod.serviceLengthAttributeKey,
        vatInclusiveText: pricePeriod.vatInclusiveText,
        vatExclusiveText: pricePeriod.vatExclusiveText,
        billingPeriodText: pricePeriod.billingPeriodText,
        perPeriodText: displayPeriod.perPeriodText,
        billingPeriodDisclaimerText: billingPeriodDisclaimerText,
        promotionalPricingDisclaimerText: pricePeriod.promotionalPricingDisclaimerText,
        promotionalPricingDisclaimerSymbol: pricePeriod.promotionalPricingDisclaimerSymbol,
        promotionalPricingDisclaimerDescription: pricePeriod.promotionalPricingDisclaimerDescription,
        monthsInPeriod: pricePeriod.monthsInPeriod,
        billingPeriodAttribute: pricePeriod.billingPeriodAttribute,
        freePricingDisclaimerText: pricePeriod.freePricingDisclaimerText,
    };
}
function getPromotionalDisclaimerContent(periods, periodKey) {
    invariant(periods, 'The periods array is required');
    var period = getPeriod(periods, periodKey);
    return {
        promotionalPricingDisclaimerText: period.promotionalPricingDisclaimerText,
        promotionalPricingDisclaimerSymbol: period.promotionalPricingDisclaimerSymbol,
        promotionalPricingDisclaimerDescription: period.promotionalPricingDisclaimerDescription,
    };
}
function PricingContentProvider(_a) {
    var pricingContent = _a.pricingContent, children = _a.children;
    invariant(pricingContent, 'PricingContentProvider requires pricingContent');
    return (React.createElement(PricingContentContext.Provider, { value: pricingContent }, children));
}
function useBillingPeriodContent(billingPeriodKey, displayPeriodKey) {
    var context = React.useContext(PricingContentContext);
    invariant(context, 'useBillingPeriodContent must be used within a PricingContentProvider');
    return getBillingPeriodContent(context, billingPeriodKey, displayPeriodKey || billingPeriodKey);
}
function usePromotionalDisclaimerContent(billingPeriodKey) {
    var context = React.useContext(PricingContentContext);
    invariant(context, 'usePromotionalDisclaimerContent must be used within a PricingContentProvider');
    return getPromotionalDisclaimerContent(context, billingPeriodKey);
}

var getVatText = function (pricePeriodContent, pricingContext) {
    if (!pricingContext.isVatSupported) {
        return '';
    }
    return pricingContext.isVatInclusive
        ? pricePeriodContent.vatInclusiveText
        : pricePeriodContent.vatExclusiveText;
};
var useDisplayContent = function (pricePeriodKey, displayPeriodKey) {
    var pricingContextOption = usePricingContext();
    var displayPeriodContent = useBillingPeriodContent(displayPeriodKey);
    var pricePeriodContent = useBillingPeriodContent(pricePeriodKey, displayPeriodContent.serviceLengthAttributeKey);
    if (isNone(pricingContextOption)) {
        return {};
    }
    var pricingContext = pricingContextOption.value;
    var vatText = getVatText(pricePeriodContent, pricingContext);
    return {
        displayPeriodContent: displayPeriodContent,
        pricePeriodContent: pricePeriodContent,
        pricingContext: pricingContext,
        vatText: vatText,
    };
};

var useDisplayPriceContent = function (price, displayPeriodKey, productIdentifier, overrideSales) {
    var displayContent = useDisplayContent((price === null || price === void 0 ? void 0 : price.serviceLengthAttributeKey) ||
        (productIdentifier === null || productIdentifier === void 0 ? void 0 : productIdentifier.productAttributes.find(function (attr) { return attr.key === SERVICE_LENGTH_ATTRIBUTE_NAME; }).value), displayPeriodKey);
    var displayPeriodContent = displayContent.displayPeriodContent, pricePeriodContent = displayContent.pricePeriodContent, pricingContext = displayContent.pricingContext, vatText = displayContent.vatText;
    var _a = useDisplayPrice(price, displayPeriodContent, pricePeriodContent, pricingContext, overrideSales), isFree = _a.isFree, displayListPrice = _a.displayListPrice, formattedListPrice = _a.formattedListPrice, formattedListPriceParts = _a.formattedListPriceParts, isDiscounted = _a.isDiscounted, displayDiscountPrice = _a.displayDiscountPrice, formattedDiscountPrice = _a.formattedDiscountPrice, formattedDiscountPriceParts = _a.formattedDiscountPriceParts;
    if (!price || Object.keys(displayContent).length === 0) {
        return {};
    }
    return {
        displayPeriodContent: displayPeriodContent,
        pricePeriodContent: pricePeriodContent,
        isFree: isFree,
        displayListPrice: displayListPrice,
        formattedListPrice: formattedListPrice,
        formattedListPriceParts: formattedListPriceParts,
        isDiscounted: isDiscounted,
        displayDiscountPrice: displayDiscountPrice,
        formattedDiscountPrice: formattedDiscountPrice,
        formattedDiscountPriceParts: formattedDiscountPriceParts,
        vatText: vatText,
    };
};

var PriceV1Theme = function (_a) {
    var className = _a.className, isLoading = _a.isLoading, price = _a.price, displayPeriodKey = _a.displayPeriodKey, displayPeriod = _a.displayPeriod, overrideSales = _a.overrideSales;
    if (isLoading) {
        var defaultPriceParts = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
        }).formatToParts(0);
        return (React.createElement(PriceV1ThemeUI, { className: className, isLoading: true, formattedListPriceParts: defaultPriceParts, formattedDiscountPriceParts: defaultPriceParts, displayPeriod: displayPeriod }));
    }
    return (React.createElement(PriceV1ThemeData, { className: className, price: price, displayPeriodKey: displayPeriodKey, displayPeriod: displayPeriod, overrideSales: overrideSales }));
};
var PriceV1ThemeData = function (_a) {
    var className = _a.className, price = _a.price, displayPeriodKey = _a.displayPeriodKey, displayPeriod = _a.displayPeriod, overrideSales = _a.overrideSales;
    var _b = useDisplayPriceContent(price, displayPeriodKey, undefined, overrideSales), pricePeriodContent = _b.pricePeriodContent, formattedListPriceParts = _b.formattedListPriceParts, formattedDiscountPriceParts = _b.formattedDiscountPriceParts, isDiscounted = _b.isDiscounted;
    return (React.createElement(PriceV1ThemeUI, { className: className, isLoading: false, pricePeriodContent: pricePeriodContent, formattedListPriceParts: formattedListPriceParts, formattedDiscountPriceParts: formattedDiscountPriceParts, isDiscounted: isDiscounted, displayPeriod: displayPeriod }));
};
var PriceV1ThemeUI = function (_a) {
    var _b, _c, _d, _e;
    var className = _a.className, isLoading = _a.isLoading, pricePeriodContent = _a.pricePeriodContent, formattedListPriceParts = _a.formattedListPriceParts, formattedDiscountPriceParts = _a.formattedDiscountPriceParts, isDiscounted = _a.isDiscounted, _f = _a.displayPeriod, displayPeriod = _f === void 0 ? true : _f;
    var currency = formattedListPriceParts.find(function (part) { return part.type === 'currency'; }).value;
    var priceDigits = formattedListPriceParts
        .filter(function (part) { return part.type === 'group' || part.type === 'integer'; })
        .reduce(function (formattedPrice, part) { return "".concat(formattedPrice).concat(part.value); }, '');
    var priceDecimal = (_b = formattedListPriceParts.find(function (part) { return part.type === 'decimal'; })) === null || _b === void 0 ? void 0 : _b.value;
    var priceFraction = (_c = formattedListPriceParts.find(function (part) { return part.type === 'fraction' && part.value !== '00'; })) === null || _c === void 0 ? void 0 : _c.value;
    var discountDigits = formattedDiscountPriceParts
        .filter(function (part) { return part.type === 'group' || part.type === 'integer'; })
        .reduce(function (formattedPrice, part) { return "".concat(formattedPrice).concat(part.value); }, '');
    var discountDecimal = (_d = formattedDiscountPriceParts.find(function (part) { return part.type === 'decimal'; })) === null || _d === void 0 ? void 0 : _d.value;
    var discountFraction = (_e = formattedDiscountPriceParts.find(function (part) { return part.type === 'fraction'; })) === null || _e === void 0 ? void 0 : _e.value;
    return (React.createElement(Box, { className: "price-v1__container", component: "span" },
        React.createElement(Typography, { component: "span", className: classnames(className, 'price-v1', {
                'price-v1__discounted': isDiscounted,
                'price-v1__loading': isLoading,
            }) },
            React.createElement(Typography, { component: "span", fontSize: "small", fontWeight: "bold", className: "price__currency" }, currency),
            React.createElement(Typography, { component: "span", fontSize: isDiscounted ? 'small' : 'large', fontWeight: "bold", className: "price__price" }, priceDigits),
            priceFraction && (React.createElement(Typography, { component: "span", fontSize: "small", className: "price__fraction" },
                isDiscounted ? (priceDecimal) : (React.createElement(Typography, { component: "span", className: "price__visible-xs-sm" }, priceDecimal)),
                priceFraction)),
            isDiscounted && React.createElement("br", null),
            isDiscounted && (React.createElement(React.Fragment, null,
                React.createElement(Typography, { component: "span", fontSize: "xsmall", fontWeight: "bold", className: "discount__currency" }, currency),
                React.createElement(Typography, { component: "span", fontSize: "x2large", fontWeight: "bold", className: "discount__price" }, discountDigits),
                React.createElement(Typography, { component: "span", fontSize: "xsmall", className: "discount__fraction" }, discountFraction ? (React.createElement(React.Fragment, null,
                    React.createElement(Typography, { component: "span", className: "price__visible-xs-sm" }, discountDecimal),
                    discountFraction)) : (React.createElement(Typography, { component: "span", className: "price__hidden-xs-sm" }, "00"))))),
            displayPeriod && (React.createElement(Typography, { component: "span", fontSize: "xsmall", className: "price__period" }, pricePeriodContent === null || pricePeriodContent === void 0 ? void 0 : pricePeriodContent.perPeriodText))),
        isLoading && (React.createElement(FlexBox, { component: "span", alignItems: "center", className: "price-v1__spinner" },
            React.createElement(Spinner, { size: "mini", accessibleText: "Loading..." })))));
};

var PriceV2Theme = function (_a) {
    var className = _a.className, isLoading = _a.isLoading, price = _a.price, displayPeriodKey = _a.displayPeriodKey, displayPeriod = _a.displayPeriod, overrideSales = _a.overrideSales;
    if (isLoading) {
        var defaultPriceParts = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
        }).formatToParts(0);
        return (React.createElement(PriceV2ThemeUI, { className: className, isLoading: true, formattedListPriceParts: defaultPriceParts, formattedDiscountPriceParts: defaultPriceParts, isDiscounted: false }));
    }
    return (React.createElement(PriceV2ThemeData, { className: className, price: price, displayPeriodKey: displayPeriodKey, displayPeriod: displayPeriod, overrideSales: overrideSales }));
};
var PriceV2ThemeData = function (_a) {
    var className = _a.className, price = _a.price, displayPeriodKey = _a.displayPeriodKey, displayPeriod = _a.displayPeriod, overrideSales = _a.overrideSales;
    var _b = useDisplayPriceContent(price, displayPeriodKey, undefined, overrideSales), pricePeriodContent = _b.pricePeriodContent, formattedListPriceParts = _b.formattedListPriceParts, formattedDiscountPriceParts = _b.formattedDiscountPriceParts, isDiscounted = _b.isDiscounted;
    return (React.createElement(PriceV2ThemeUI, { className: className, isLoading: false, pricePeriodContent: pricePeriodContent, formattedListPriceParts: formattedListPriceParts, formattedDiscountPriceParts: formattedDiscountPriceParts, isDiscounted: isDiscounted, displayPeriod: displayPeriod }));
};
var PriceV2ThemeUI = function (_a) {
    var _b, _c, _d;
    var className = _a.className, isLoading = _a.isLoading, _e = _a.displayPeriod, displayPeriod = _e === void 0 ? true : _e, pricePeriodContent = _a.pricePeriodContent, formattedListPriceParts = _a.formattedListPriceParts, formattedDiscountPriceParts = _a.formattedDiscountPriceParts, isDiscounted = _a.isDiscounted;
    var currency = formattedListPriceParts.find(function (part) { return part.type === 'currency'; }).value;
    var priceDigits = formattedListPriceParts
        .filter(function (part) { return part.type === 'group' || part.type === 'integer'; })
        .reduce(function (formattedPrice, part) { return "".concat(formattedPrice).concat(part.value); }, '');
    var priceDecimal = (_b = formattedListPriceParts.find(function (part) { return part.type === 'decimal'; })) === null || _b === void 0 ? void 0 : _b.value;
    var priceFraction = ((_c = formattedListPriceParts.find(function (part) { return part.type === 'fraction' && part.value !== '00'; })) === null || _c === void 0 ? void 0 : _c.value) || (isDiscounted ? '' : '00');
    var discountDigits = formattedDiscountPriceParts
        .filter(function (part) { return part.type === 'group' || part.type === 'integer'; })
        .reduce(function (formattedPrice, part) { return "".concat(formattedPrice).concat(part.value); }, '');
    var discountFraction = ((_d = formattedDiscountPriceParts.find(function (part) { return part.type === 'fraction'; })) === null || _d === void 0 ? void 0 : _d.value) || '00';
    return (React.createElement(Box, { className: "price-v2__container", component: "span" },
        React.createElement(FlexBox, { component: "span", alignItems: "baseline", className: classnames(className, 'price-v2', {
                'price-v2__discounted': isDiscounted,
                'price-v2__loading': isLoading,
            }) },
            React.createElement(Typography, { component: "span", fontSize: isDiscounted ? 'large' : 'small', fontWeight: "bold", className: "price__currency" }, currency),
            React.createElement(Typography, { component: "span", fontSize: isDiscounted ? 'large' : 'x3large', fontWeight: "bold", className: "price__price" }, priceDigits),
            priceFraction && (React.createElement(Typography, { component: "span", fontSize: isDiscounted ? 'large' : 'small', fontWeight: isDiscounted ? 'bold' : 'normal', className: "price__fraction" },
                isDiscounted ? priceDecimal : '',
                priceFraction)),
            isDiscounted && (React.createElement(React.Fragment, null,
                React.createElement(Typography, { ml: '2', component: "span", fontSize: "small", fontWeight: "bold", className: "discount__currency" }, currency),
                React.createElement(Typography, { component: "span", fontSize: "x3large", fontWeight: "bold", className: "discount__price" }, discountDigits),
                React.createElement(Typography, { component: "span", fontSize: "small", className: "discount__fraction" }, discountFraction))),
            displayPeriod && (React.createElement(Typography, { component: "span", fontSize: "xsmall", className: "price__period" }, pricePeriodContent === null || pricePeriodContent === void 0 ? void 0 : pricePeriodContent.perPeriodText))),
        isLoading && (React.createElement(FlexBox, { component: "span", alignItems: "center", className: "price-v2__spinner" },
            React.createElement(Spinner, { size: "mini", accessibleText: "Loading..." })))));
};

var PriceDefaultTheme = function (_a) {
    var className = _a.className, isLoading = _a.isLoading, price = _a.price, displayPeriodKey = _a.displayPeriodKey, displayPeriod = _a.displayPeriod, priceTag = _a.priceTag, containerTag = _a.containerTag, priceTextSize = _a.priceTextSize, priceTextWeight = _a.priceTextWeight, discountTextSize = _a.discountTextSize, discountTextWeight = _a.discountTextWeight, discountAligned = _a.discountAligned, overrideSales = _a.overrideSales;
    if (isLoading) {
        return (React.createElement(PriceDefaultThemeInternalUI, { className: className, isLoading: true, formattedListPrice: "0", formattedDiscountPrice: "0", displayPeriod: displayPeriod, containerTag: containerTag, priceTag: priceTag, priceTextSize: priceTextSize, priceTextWeight: priceTextWeight, discountTextSize: discountTextSize, discountTextWeight: discountTextWeight, discountAligned: discountAligned }));
    }
    return (React.createElement(PriceDefaultThemeData, { className: className, price: price, displayPeriodKey: displayPeriodKey, displayPeriod: displayPeriod, containerTag: containerTag, priceTag: priceTag, priceTextSize: priceTextSize, priceTextWeight: priceTextWeight, discountTextSize: discountTextSize, discountTextWeight: discountTextWeight, discountAligned: discountAligned, overrideSales: overrideSales }));
};
var PriceDefaultThemeData = function (_a) {
    var className = _a.className, price = _a.price, displayPeriodKey = _a.displayPeriodKey, displayPeriod = _a.displayPeriod, priceTag = _a.priceTag, containerTag = _a.containerTag, priceTextSize = _a.priceTextSize, priceTextWeight = _a.priceTextWeight, discountTextSize = _a.discountTextSize, discountTextWeight = _a.discountTextWeight, discountAligned = _a.discountAligned, overrideSales = _a.overrideSales;
    var _b = useDisplayPriceContent(price, displayPeriodKey, undefined, overrideSales), pricePeriodContent = _b.pricePeriodContent, formattedListPrice = _b.formattedListPrice, formattedDiscountPrice = _b.formattedDiscountPrice, isDiscounted = _b.isDiscounted;
    return (React.createElement(PriceDefaultThemeInternalUI, { className: className, isLoading: false, pricePeriodContent: pricePeriodContent, formattedListPrice: formattedListPrice, formattedDiscountPrice: formattedDiscountPrice, isDiscounted: isDiscounted, displayPeriod: displayPeriod, containerTag: containerTag, priceTag: priceTag, priceTextSize: priceTextSize, priceTextWeight: priceTextWeight, discountTextSize: discountTextSize, discountTextWeight: discountTextWeight, discountAligned: discountAligned }));
};
var PriceDefaultThemeInternalUI = function (_a) {
    var className = _a.className, isLoading = _a.isLoading, pricePeriodContent = _a.pricePeriodContent, formattedListPrice = _a.formattedListPrice, formattedDiscountPrice = _a.formattedDiscountPrice, isDiscounted = _a.isDiscounted, _b = _a.displayPeriod, displayPeriod = _b === void 0 ? true : _b, _c = _a.containerTag, containerTag = _c === void 0 ? 'span' : _c, _d = _a.priceTag, priceTag = _d === void 0 ? 'span' : _d, priceTextSize = _a.priceTextSize, priceTextWeight = _a.priceTextWeight, discountTextSize = _a.discountTextSize, discountTextWeight = _a.discountTextWeight, discountAligned = _a.discountAligned;
    return (React.createElement(Box, { className: "pricing__container", component: containerTag },
        React.createElement(Typography, { component: priceTag, className: classnames(className, 'pricing__list-price__container', {
                'pricing__comparative-pricing': isDiscounted,
                pricing__loading: isLoading,
            }) },
            formattedListPrice && (React.createElement(Typography, { fontSize: priceTextSize, component: "span", fontWeight: priceTextWeight, className: "pricing__list-price" }, formattedListPrice)),
            displayPeriod && (React.createElement(Typography, { fontSize: priceTextSize, component: "span", fontWeight: priceTextWeight, className: "pricing__price-period" }, pricePeriodContent === null || pricePeriodContent === void 0 ? void 0 : pricePeriodContent.perPeriodText)),
            isDiscounted && (React.createElement(Typography, { component: "span", fontSize: priceTextSize, fontWeight: priceTextWeight }, "\u00A0")),
            isDiscounted && (React.createElement(Typography, { className: classnames('pricing__discount-price', {
                    'pricing__discount-price__container': !!discountTextSize,
                    'pricing__discount-price__aligned': discountAligned,
                }), component: "span" },
                formattedDiscountPrice && (React.createElement(Typography, { component: "span", fontWeight: discountTextWeight, fontSize: discountTextSize }, formattedDiscountPrice)),
                React.createElement(Typography, { component: "span", fontWeight: discountTextWeight, fontSize: discountTextSize }, pricePeriodContent === null || pricePeriodContent === void 0 ? void 0 : pricePeriodContent.promotionalPricingDisclaimerSymbol),
                displayPeriod && (React.createElement(Typography, { fontSize: discountTextSize, component: "span", fontWeight: discountTextWeight }, pricePeriodContent === null || pricePeriodContent === void 0 ? void 0 : pricePeriodContent.perPeriodText))))),
        isLoading && (React.createElement(FlexBox, { component: "span", alignItems: "center", className: "pricing__spinner" },
            React.createElement(Spinner, { size: "mini", accessibleText: "Loading..." })))));
};

var Price = function (_a) {
    var className = _a.className, isLoading = _a.isLoading, price = _a.price, displayPeriodKey = _a.displayPeriodKey, displayPeriod = _a.displayPeriod, containerTag = _a.containerTag, priceTag = _a.priceTag, priceTextSize = _a.priceTextSize, priceTextWeight = _a.priceTextWeight, discountTextSize = _a.discountTextSize, discountTextWeight = _a.discountTextWeight, discountAligned = _a.discountAligned, _b = _a.uiVersion, uiVersion = _b === void 0 ? 0 : _b, overrideSales = _a.overrideSales, setIsDiscounted = _a.setIsDiscounted;
    if (setIsDiscounted && price && !isLoading) {
        setIsDiscounted(price.taxed.listPrice > price.taxed.discountPrice || overrideSales);
    }
    switch (uiVersion) {
        case 1:
            return (React.createElement(PriceV1Theme, { className: className, isLoading: !price || isLoading, price: price, displayPeriodKey: displayPeriodKey, displayPeriod: displayPeriod, overrideSales: overrideSales }));
        case 2:
            return (React.createElement(PriceV2Theme, { className: className, isLoading: !price || isLoading, price: price, displayPeriodKey: displayPeriodKey, displayPeriod: displayPeriod, overrideSales: overrideSales }));
        default:
            return (React.createElement(PriceDefaultTheme, { className: className, isLoading: !price || isLoading, price: price, displayPeriodKey: displayPeriodKey, displayPeriod: displayPeriod, containerTag: containerTag, priceTag: priceTag, priceTextSize: priceTextSize, priceTextWeight: priceTextWeight, discountTextSize: discountTextSize, discountTextWeight: discountTextWeight, discountAligned: discountAligned, overrideSales: overrideSales }));
    }
};

var defaultConfig$1 = {
    pricingApi: {
        baseUrl: 'https://vistaprint-org-product-catalog-product-pricing-service.products.vpsvc.com',
        operations: {
            getPrice: {
                timeoutMS: 3 * 1000,
                cache: {
                    maxAgeMS: 60 * 1000,
                    maxSize: 10,
                },
                retry: {
                    policy: RetryPolicy.LinearBackOff,
                    count: 1,
                },
                parameters: {
                    requestor: 'Digital Merchandising',
                    merchantId: 'Vistaprint',
                },
            },
        },
    },
};

function queryStringToJSON(qs) {
    qs = qs || window.location.search.slice(1);
    var pairs = qs.split('&');
    var result = {};
    pairs.forEach(function (p) {
        var pair = p.split('=');
        var key = pair[0];
        var value = decodeURIComponent(pair[1] || '');
        if (result[key]) {
            if (Object.prototype.toString.call(result[key]) === '[object Array]') {
                result[key].push(value);
            }
            else {
                result[key] = [result[key], value];
            }
        }
        else {
            result[key] = value;
        }
    });
    return JSON.parse(JSON.stringify(result));
}
function getPricingApiRequestParameters(pricingContext, productIdentifier, quantity, opConfig) {
    var pricingContextParams = queryStringToJSON(pricingContext.contextAsQueryString);
    var params = productIdentifier.productAttributes.reduce(function (p, attr) {
        var _a;
        return (__assign(__assign({}, p), (_a = {}, _a["Selections[".concat(attr.key, "]")] = attr.value, _a)));
    }, __assign(__assign({}, pricingContextParams), { requestor: opConfig.parameters.requestor, quantities: quantity.toString(), productKey: productIdentifier.productKey, productVersion: productIdentifier.productVersion }));
    return params;
}
var transformPricingApiResponseData = function (locale, productIdentifier, quantity, response) {
    var _a;
    var estimatedPrice = (_a = response === null || response === void 0 ? void 0 : response.estimatedPrices) === null || _a === void 0 ? void 0 : _a[quantity];
    var price = {
        quantity: quantity,
        taxed: {
            listPrice: estimatedPrice === null || estimatedPrice === void 0 ? void 0 : estimatedPrice.totalListPrice.taxed,
            discountPrice: estimatedPrice === null || estimatedPrice === void 0 ? void 0 : estimatedPrice.totalDiscountedPrice.taxed,
        },
        untaxed: {
            listPrice: estimatedPrice === null || estimatedPrice === void 0 ? void 0 : estimatedPrice.totalListPrice.untaxed,
            discountPrice: estimatedPrice === null || estimatedPrice === void 0 ? void 0 : estimatedPrice.totalDiscountedPrice.untaxed,
        },
        currency: response.currency,
        minimumFractionDigits: response.fractionDigits,
        culture: locale,
        serviceLengthAttributeKey: getServiceLength(productIdentifier),
    };
    return price;
};

var apiConfig$1 = defaultConfig$1.pricingApi;
var opConfig$1 = apiConfig$1.operations.getPrice;
var pricingClientDispenser = new HttpClientDispenser(apiConfig$1, opConfig$1);
var pricingHookDispenser = new Dispenser(function () {
    return makeUseAxios({
        axios: pricingClientDispenser.getInstance(),
        defaultOptions: { manual: true },
    });
});
function usePrice(productIdentifier, quantity) {
    if (quantity === void 0) { quantity = 1; }
    var pricingContext = usePricingContext();
    var locale = useLocale().identifier;
    var _a = pricingHookDispenser.getInstance()({}), responseValues = _a[0], fetchPrice = _a[1];
    useEffect(function () {
        var logger = getLibLogger();
        if (isSome(pricingContext)) {
            var params = getPricingApiRequestParameters(pricingContext.value, productIdentifier, quantity, opConfig$1);
            var transformResponse = function (data) {
                if (!data)
                    return;
                return transformPricingApiResponseData(locale, productIdentifier, quantity, data);
            };
            var newTransformers = []
                .concat(pricingClientDispenser.getInstance().defaults.transformResponse)
                .concat(transformResponse);
            var axiosConfig = {
                url: 'https://website-pricing-service-cdn.prices.cimpress.io/v4/prices/estimated',
                method: 'get',
                params: params,
                transformResponse: newTransformers,
                paramsSerializer: function (params) {
                    return Object.entries(params)
                        .reduce(function (query, param) {
                        return Array.isArray(param[1])
                            ? "".concat(query).concat(param[1].reduce(function (query, arrayParam) {
                                return "".concat(query).concat(param[0], "=").concat(arrayParam, "&");
                            }, ''))
                            : "".concat(query).concat(param[0], "=").concat(param[1], "&");
                    }, '')
                        .split(' ')
                        .join('+');
                },
            };
            fetchPrice(axiosConfig)
                .then(function () { })
                .catch(function (error) {
                logger.error('Error while receiving prices', error);
            });
        }
    }, [fetchPrice, locale, pricingContext, productIdentifier, quantity]);
    return responseValues;
}

var PriceContainer = function (_a) {
    var className = _a.className, productIdentifier = _a.productIdentifier, quantity = _a.quantity, _b = _a.priceDataProvided, priceDataProvided = _b === void 0 ? false : _b, isLoading = _a.isLoading, priceData = _a.priceData, displayPeriodKey = _a.displayPeriodKey, displayPeriod = _a.displayPeriod, containerTag = _a.containerTag, priceTag = _a.priceTag, priceTextSize = _a.priceTextSize, priceTextWeight = _a.priceTextWeight, discountTextSize = _a.discountTextSize, discountTextWeight = _a.discountTextWeight, discountAligned = _a.discountAligned, _c = _a.uiVersion, uiVersion = _c === void 0 ? 0 : _c, overrideSales = _a.overrideSales, setIsDiscounted = _a.setIsDiscounted;
    return priceDataProvided ? (React.createElement(Price, { className: className, isLoading: isLoading, price: priceData, displayPeriodKey: displayPeriodKey, displayPeriod: displayPeriod, containerTag: containerTag, priceTag: priceTag, priceTextSize: priceTextSize, priceTextWeight: priceTextWeight, discountTextSize: discountTextSize, discountTextWeight: discountTextWeight, discountAligned: discountAligned, uiVersion: uiVersion, overrideSales: overrideSales, setIsDiscounted: setIsDiscounted })) : (React.createElement(PriceRequester$2, { className: className, productIdentifier: productIdentifier, quantity: quantity, displayPeriodKey: displayPeriodKey, displayPeriod: displayPeriod, containerTag: containerTag, priceTag: priceTag, priceTextSize: priceTextSize, priceTextWeight: priceTextWeight, discountTextSize: discountTextSize, discountTextWeight: discountTextWeight, discountAligned: discountAligned, uiVersion: uiVersion, overrideSales: overrideSales, setIsDiscounted: setIsDiscounted }));
};
var PriceRequester$2 = function (_a) {
    var className = _a.className, productIdentifier = _a.productIdentifier, quantity = _a.quantity, displayPeriodKey = _a.displayPeriodKey, displayPeriod = _a.displayPeriod, containerTag = _a.containerTag, priceTag = _a.priceTag, priceTextSize = _a.priceTextSize, priceTextWeight = _a.priceTextWeight, discountTextSize = _a.discountTextSize, discountTextWeight = _a.discountTextWeight, discountAligned = _a.discountAligned, uiVersion = _a.uiVersion, overrideSales = _a.overrideSales, setIsDiscounted = _a.setIsDiscounted;
    var _b = usePrice(productIdentifier, quantity), price = _b.data, isLoading = _b.loading;
    return (React.createElement(Price, { className: className, isLoading: isLoading, price: price, displayPeriodKey: displayPeriodKey, displayPeriod: displayPeriod, containerTag: containerTag, priceTag: priceTag, priceTextSize: priceTextSize, priceTextWeight: priceTextWeight, discountTextSize: discountTextSize, discountTextWeight: discountTextWeight, discountAligned: discountAligned, uiVersion: uiVersion, overrideSales: overrideSales, setIsDiscounted: setIsDiscounted }));
};

var PromotionalDisclaimer = function (_a) {
    var className = _a.className, billingPeriodKey = _a.billingPeriodKey;
    var promotionalPricingContent = usePromotionalDisclaimerContent(billingPeriodKey);
    return (React.createElement(Typography, { component: "span", className: className }, promotionalPricingContent.promotionalPricingDisclaimerText && (React.createElement(React.Fragment, null,
        promotionalPricingContent.promotionalPricingDisclaimerSymbol,
        promotionalPricingContent.promotionalPricingDisclaimerText))));
};

var Disclaimer = function (_a) {
    var className = _a.className, pricePeriodKey = _a.pricePeriodKey, displayPeriodKey = _a.displayPeriodKey;
    var pricePeriodContent = useDisplayContent(pricePeriodKey, displayPeriodKey).pricePeriodContent;
    return (React.createElement(Typography, { component: "span", className: className }, (pricePeriodContent === null || pricePeriodContent === void 0 ? void 0 : pricePeriodContent.billingPeriodDisclaimerText) && (React.createElement(React.Fragment, null, pricePeriodContent === null || pricePeriodContent === void 0 ? void 0 : pricePeriodContent.billingPeriodDisclaimerText))));
};

var DisclaimerContainer = function (_a) {
    var className = _a.className, pricePeriodKey = _a.pricePeriodKey, displayPeriodKey = _a.displayPeriodKey;
    return (React.createElement(Disclaimer, { className: className, pricePeriodKey: pricePeriodKey, displayPeriodKey: displayPeriodKey }));
};

var DisclaimerWithPrice = function (_a) {
    var className = _a.className, isLoading = _a.isLoading, price = _a.price, displayPeriodKey = _a.displayPeriodKey, displaySpinner = _a.displaySpinner, overrideSales = _a.overrideSales;
    if (isLoading) {
        return (React.createElement(DisclaimerWithPriceUI, { className: className, isLoading: true, displaySpinner: displaySpinner }));
    }
    return (React.createElement(DisclaimerWithPriceData, { className: className, price: price, displayPeriodKey: displayPeriodKey, overrideSales: overrideSales }));
};
var DisclaimerWithPriceData = function (_a) {
    var className = _a.className, price = _a.price, displayPeriodKey = _a.displayPeriodKey, overrideSales = _a.overrideSales;
    var _b = useDisplayPriceContent(price, displayPeriodKey, undefined, overrideSales), pricePeriodContent = _b.pricePeriodContent, isDiscounted = _b.isDiscounted, isFree = _b.isFree;
    var _c = useDisplayPriceContent(price, '1 Year', undefined, overrideSales), disclaimerFormattedListPrice = _c.formattedListPrice, disclaimerFormattedDiscountPrice = _c.formattedDiscountPrice;
    return (React.createElement(DisclaimerWithPriceUI, { className: className, isLoading: false, pricePeriodContent: pricePeriodContent, disclaimerFormattedListPrice: disclaimerFormattedListPrice, disclaimerFormattedDiscountPrice: disclaimerFormattedDiscountPrice, isDiscounted: isDiscounted, isFree: isFree, displaySpinner: false }));
};
var DisclaimerWithPriceUI = function (_a) {
    var className = _a.className, isLoading = _a.isLoading, pricePeriodContent = _a.pricePeriodContent, disclaimerFormattedListPrice = _a.disclaimerFormattedListPrice, disclaimerFormattedDiscountPrice = _a.disclaimerFormattedDiscountPrice, isDiscounted = _a.isDiscounted, isFree = _a.isFree, _b = _a.displaySpinner, displaySpinner = _b === void 0 ? true : _b;
    var isPriceAndContentLoading = isLoading || !pricePeriodContent;
    return (React.createElement(Typography, { className: "disclaimer-with-price__container", component: "span" },
        React.createElement(Typography, { className: classnames(className, 'disclaimer-with-price', {
                'disclaimer-with-price__discounted': isDiscounted,
                'disclaimer-with-price__loading': isPriceAndContentLoading,
                'disclaimer-with-price__free': isFree,
            }), component: "span" }, isPriceAndContentLoading ? (React.createElement(React.Fragment, null, "Loading...")) : isFree ? (React.createElement(React.Fragment, null, pricePeriodContent.freePricingDisclaimerText)) : ((isDiscounted
            ? pricePeriodContent.promotionalPricingDisclaimerText
            : pricePeriodContent.billingPeriodDisclaimerText) && (React.createElement(React.Fragment, null,
            React.createElement(Typography, { component: "span", className: "disclaimer-with-price__price" }, disclaimerFormattedListPrice),
            isDiscounted && (React.createElement(Typography, { component: "span", className: "disclaimer-with-price__discount" },
                ' ',
                disclaimerFormattedDiscountPrice)),
            React.createElement(Typography, { component: "span", className: "disclaimer-with-price__text" },
                ' ',
                isDiscounted
                    ? pricePeriodContent.promotionalPricingDisclaimerText
                    : pricePeriodContent.billingPeriodDisclaimerText))))),
        isPriceAndContentLoading && displaySpinner && (React.createElement(FlexBox, { component: "span", alignItems: "center", className: "disclaimer-with-price__spinner" },
            React.createElement(Spinner, { size: "tiny", accessibleText: "Loading..." })))));
};

var DisclaimerWithPriceContainer = function (_a) {
    var className = _a.className, productIdentifier = _a.productIdentifier, quantity = _a.quantity, _b = _a.priceDataProvided, priceDataProvided = _b === void 0 ? false : _b, isLoading = _a.isLoading, priceData = _a.priceData, displayPeriodKey = _a.displayPeriodKey, displaySpinner = _a.displaySpinner, overrideSales = _a.overrideSales;
    return priceDataProvided ? (React.createElement(DisclaimerWithPrice, { className: className, isLoading: isLoading, price: priceData, displayPeriodKey: displayPeriodKey, displaySpinner: displaySpinner, overrideSales: overrideSales })) : (React.createElement(PriceRequester$1, { className: className, productIdentifier: productIdentifier, quantity: quantity, displayPeriodKey: displayPeriodKey, displaySpinner: displaySpinner, overrideSales: overrideSales }));
};
var PriceRequester$1 = function (_a) {
    var className = _a.className, productIdentifier = _a.productIdentifier, quantity = _a.quantity, displayPeriodKey = _a.displayPeriodKey, displaySpinner = _a.displaySpinner, overrideSales = _a.overrideSales;
    var _b = usePrice(productIdentifier, quantity), price = _b.data, isLoading = _b.loading;
    return (React.createElement(DisclaimerWithPrice, { className: className, isLoading: isLoading || !price, price: price, displayPeriodKey: displayPeriodKey, displaySpinner: displaySpinner, overrideSales: overrideSales }));
};

var DisclaimerWithSaveAmount = function (_a) {
    var className = _a.className, isLoading = _a.isLoading, currentPrice = _a.currentPrice, upgradePrice = _a.upgradePrice, displayPeriodKey = _a.displayPeriodKey, displaySpinner = _a.displaySpinner, overrideSales = _a.overrideSales;
    if (isLoading) {
        return (React.createElement(DisclaimerWithSaveAmountUI, { className: className, isLoading: true, displaySpinner: displaySpinner }));
    }
    return (React.createElement(DisclaimerWithSaveAmountData, { className: className, currentPrice: currentPrice, upgradePrice: upgradePrice, displayPeriodKey: displayPeriodKey, overrideSales: overrideSales }));
};
var DisclaimerWithSaveAmountData = function (_a) {
    var className = _a.className, currentPrice = _a.currentPrice, upgradePrice = _a.upgradePrice, displayPeriodKey = _a.displayPeriodKey, overrideSales = _a.overrideSales;
    var _b = useDisplayPriceContent(currentPrice, displayPeriodKey, undefined, overrideSales), currentPricePeriodContent = _b.pricePeriodContent, displayListCurrentPrice = _b.displayListPrice, isCurrentPriceDiscounted = _b.isDiscounted, displayDiscountCurrentPrice = _b.displayDiscountPrice, isCurrentPriceFree = _b.isFree;
    var _c = useDisplayPriceContent(upgradePrice, displayPeriodKey, undefined, overrideSales), displayListUpgradePrice = _c.displayListPrice, isUpgradePriceDiscounted = _c.isDiscounted, displayDiscountUpgradePrice = _c.displayDiscountPrice;
    return (React.createElement(DisclaimerWithSaveAmountUI, { className: className, isLoading: false, currentPricePeriodContent: currentPricePeriodContent, displayListCurrentPrice: displayListCurrentPrice, isCurrentPriceDiscounted: isCurrentPriceDiscounted, displayDiscountCurrentPrice: displayDiscountCurrentPrice, isCurrentPriceFree: isCurrentPriceFree, displayListUpgradePrice: displayListUpgradePrice, isUpgradePriceDiscounted: isUpgradePriceDiscounted, displayDiscountUpgradePrice: displayDiscountUpgradePrice, displaySpinner: false }));
};
var DisclaimerWithSaveAmountUI = function (_a) {
    var className = _a.className, isLoading = _a.isLoading, currentPricePeriodContent = _a.currentPricePeriodContent, displayListCurrentPrice = _a.displayListCurrentPrice, isCurrentPriceDiscounted = _a.isCurrentPriceDiscounted, displayDiscountCurrentPrice = _a.displayDiscountCurrentPrice, isCurrentPriceFree = _a.isCurrentPriceFree, displayListUpgradePrice = _a.displayListUpgradePrice, isUpgradePriceDiscounted = _a.isUpgradePriceDiscounted, displayDiscountUpgradePrice = _a.displayDiscountUpgradePrice, _b = _a.displaySpinner, displaySpinner = _b === void 0 ? true : _b;
    var displayCurrentPrice = isCurrentPriceDiscounted
        ? displayDiscountCurrentPrice
        : displayListCurrentPrice;
    var displayUpgradePrice = isUpgradePriceDiscounted
        ? displayDiscountUpgradePrice
        : displayListUpgradePrice;
    var savedPricePercentage = Math.round(100 - (displayUpgradePrice / displayCurrentPrice) * 100);
    var isPriceAndContentLoading = isLoading || !currentPricePeriodContent;
    return (React.createElement(Typography, { component: "span", className: "disclaimer-with-save-price__container" },
        React.createElement(Typography, { component: "span", className: classnames(className, 'disclaimer-with-save-price', {
                'disclaimer-with-save-price__loading': isPriceAndContentLoading,
                'disclaimer-with-save-price__free': isCurrentPriceFree,
            }) }, isPriceAndContentLoading ? (React.createElement(React.Fragment, null, "Loading...")) : isCurrentPriceFree ? (React.createElement(React.Fragment, null, currentPricePeriodContent.freePricingDisclaimerText)) : (React.createElement(React.Fragment, null, isCurrentPriceDiscounted ? (currentPricePeriodContent.promotionalPricingDisclaimerText) : (React.createElement(TokenReplacer, { template: currentPricePeriodContent.billingPeriodDisclaimerText, replacements: {
                savedPricePercentage: savedPricePercentage,
            }, convertMarkdown: true }))))),
        isPriceAndContentLoading && displaySpinner && (React.createElement(FlexBox, { component: "span", alignItems: "center", className: "disclaimer-with-price__spinner" },
            React.createElement(Spinner, { size: "tiny", accessibleText: "Loading..." })))));
};

var DisclaimerWithSaveAmountContainer = function (_a) {
    var className = _a.className, currentProductIdentifier = _a.currentProductIdentifier, upgradeProductIdentifier = _a.upgradeProductIdentifier, quantity = _a.quantity, _b = _a.priceDataProvided, priceDataProvided = _b === void 0 ? false : _b, isLoading = _a.isLoading, currentPriceData = _a.currentPriceData, upgradePriceData = _a.upgradePriceData, displayPeriodKey = _a.displayPeriodKey, displaySpinner = _a.displaySpinner, overrideSales = _a.overrideSales;
    return priceDataProvided ? (React.createElement(DisclaimerWithSaveAmount, { className: className, isLoading: isLoading, currentPrice: currentPriceData, upgradePrice: upgradePriceData, displayPeriodKey: displayPeriodKey, displaySpinner: displaySpinner, overrideSales: overrideSales })) : (React.createElement(PriceRequester, { className: className, currentProductIdentifier: currentProductIdentifier, upgradeProductIdentifier: upgradeProductIdentifier, quantity: quantity, displayPeriodKey: displayPeriodKey, displaySpinner: displaySpinner, overrideSales: overrideSales }));
};
var PriceRequester = function (_a) {
    var className = _a.className, currentProductIdentifier = _a.currentProductIdentifier, upgradeProductIdentifier = _a.upgradeProductIdentifier, quantity = _a.quantity, displayPeriodKey = _a.displayPeriodKey, displaySpinner = _a.displaySpinner, overrideSales = _a.overrideSales;
    var _b = usePrice(currentProductIdentifier, quantity), currentPrice = _b.data, iscurrentPriceLoading = _b.loading;
    var _c = usePrice(upgradeProductIdentifier, quantity), upgradePrice = _c.data, isUpgradePriceLoading = _c.loading;
    return (React.createElement(DisclaimerWithSaveAmount, { className: className, isLoading: !currentPrice ||
            !upgradePrice ||
            iscurrentPriceLoading ||
            isUpgradePriceLoading, currentPrice: currentPrice, upgradePrice: upgradePrice, displayPeriodKey: displayPeriodKey, displaySpinner: displaySpinner, overrideSales: overrideSales }));
};

var Vat = function (_a) {
    var className = _a.className, pricePeriodKey = _a.pricePeriodKey, displayPeriodKey = _a.displayPeriodKey;
    var vatText = useDisplayContent(pricePeriodKey, displayPeriodKey).vatText;
    return (React.createElement(Typography, { className: className, component: "span" }, vatText && React.createElement(React.Fragment, null, vatText)));
};

var Pricing = function (_a) {
    var containerTag = _a.containerTag, priceTag = _a.priceTag, priceTextSize = _a.priceTextSize, priceTextWeight = _a.priceTextWeight, discountTextSize = _a.discountTextSize, discountTextWeight = _a.discountTextWeight, discountAligned = _a.discountAligned, className = _a.className, isLoading = _a.isLoading, price = _a.price, displayPeriodKey = _a.displayPeriodKey, _b = _a.uiVersion, uiVersion = _b === void 0 ? 0 : _b, _c = _a.displayPeriod, displayPeriod = _c === void 0 ? true : _c, _d = _a.displayDisclaimer, displayDisclaimer = _d === void 0 ? true : _d, _e = _a.displayVat, displayVat = _e === void 0 ? true : _e, overrideSales = _a.overrideSales, displaySpinner = _a.displaySpinner, setIsDiscounted = _a.setIsDiscounted;
    if (setIsDiscounted && price && !isLoading) {
        setIsDiscounted(price.taxed.listPrice > price.taxed.discountPrice || overrideSales);
    }
    switch (uiVersion) {
        case 1:
            return (React.createElement(React.Fragment, null,
                React.createElement(PriceV1Theme, { className: className, isLoading: !price || isLoading, price: price, displayPeriodKey: displayPeriodKey, displayPeriod: displayPeriod, overrideSales: overrideSales }),
                displayDisclaimer && (React.createElement(DisclaimerWithPrice, { className: className, isLoading: !price || isLoading, price: price, displayPeriodKey: displayPeriodKey, displaySpinner: displaySpinner, overrideSales: overrideSales })),
                displayVat && (React.createElement(Vat, { className: className, pricePeriodKey: (price === null || price === void 0 ? void 0 : price.serviceLengthAttributeKey) || displayPeriodKey, displayPeriodKey: displayPeriodKey }))));
        case 2:
            return (React.createElement(React.Fragment, null,
                React.createElement(PriceV2Theme, { className: className, isLoading: !price || isLoading, price: price, displayPeriodKey: displayPeriodKey, displayPeriod: displayPeriod, overrideSales: overrideSales }),
                displayDisclaimer && (React.createElement(DisclaimerWithPrice, { className: className, isLoading: !price || isLoading, price: price, displayPeriodKey: displayPeriodKey, displaySpinner: displaySpinner, overrideSales: overrideSales })),
                displayVat && (React.createElement(Vat, { className: className, pricePeriodKey: (price === null || price === void 0 ? void 0 : price.serviceLengthAttributeKey) || displayPeriodKey, displayPeriodKey: displayPeriodKey }))));
        default:
            return (React.createElement(React.Fragment, null,
                React.createElement(PriceDefaultTheme, { className: className, isLoading: !price || isLoading, price: price, displayPeriodKey: displayPeriodKey, displayPeriod: displayPeriod, containerTag: containerTag, priceTag: priceTag, priceTextSize: priceTextSize, priceTextWeight: priceTextWeight, discountTextSize: discountTextSize, discountTextWeight: discountTextWeight, discountAligned: discountAligned, overrideSales: overrideSales }),
                displayDisclaimer && (React.createElement(Disclaimer, { className: className, pricePeriodKey: (price === null || price === void 0 ? void 0 : price.serviceLengthAttributeKey) || displayPeriodKey, displayPeriodKey: displayPeriodKey })),
                displayVat && (React.createElement(Vat, { className: className, pricePeriodKey: (price === null || price === void 0 ? void 0 : price.serviceLengthAttributeKey) || displayPeriodKey, displayPeriodKey: displayPeriodKey }))));
    }
};

var PricingContainer = function (_a) {
    var containerTag = _a.containerTag, priceTag = _a.priceTag, priceTextSize = _a.priceTextSize, priceTextWeight = _a.priceTextWeight, discountTextSize = _a.discountTextSize, discountTextWeight = _a.discountTextWeight, discountAligned = _a.discountAligned, displayPeriodKey = _a.displayPeriodKey, productIdentifier = _a.productIdentifier, quantity = _a.quantity, isLoading = _a.isLoading, priceData = _a.priceData, _b = _a.priceDataProvided, priceDataProvided = _b === void 0 ? false : _b, className = _a.className, _c = _a.uiVersion, uiVersion = _c === void 0 ? 0 : _c, displayPeriod = _a.displayPeriod, displayVat = _a.displayVat, displayDisclaimer = _a.displayDisclaimer, overrideSales = _a.overrideSales, setIsDiscounted = _a.setIsDiscounted;
    return priceDataProvided ? (React.createElement(Pricing, { containerTag: containerTag, priceTag: priceTag, priceTextSize: priceTextSize, priceTextWeight: priceTextWeight, discountTextSize: discountTextSize, discountTextWeight: discountTextWeight, discountAligned: discountAligned, isLoading: isLoading, price: priceData, displayPeriodKey: displayPeriodKey, className: className, uiVersion: uiVersion, displayPeriod: displayPeriod, displayVat: displayVat, displayDisclaimer: displayDisclaimer, overrideSales: overrideSales, setIsDiscounted: setIsDiscounted })) : (React.createElement(PricingRequester, { containerTag: containerTag, priceTag: priceTag, priceTextSize: priceTextSize, priceTextWeight: priceTextWeight, discountTextSize: discountTextSize, discountTextWeight: discountTextWeight, discountAligned: discountAligned, displayPeriodKey: displayPeriodKey, productIdentifier: productIdentifier, quantity: quantity, className: className, uiVersion: uiVersion, displayPeriod: displayPeriod, displayVat: displayVat, displayDisclaimer: displayDisclaimer, overrideSales: overrideSales, setIsDiscounted: setIsDiscounted }));
};
var PricingRequester = function (_a) {
    var containerTag = _a.containerTag, priceTag = _a.priceTag, priceTextSize = _a.priceTextSize, priceTextWeight = _a.priceTextWeight, discountTextSize = _a.discountTextSize, discountTextWeight = _a.discountTextWeight, discountAligned = _a.discountAligned, displayPeriodKey = _a.displayPeriodKey, productIdentifier = _a.productIdentifier, quantity = _a.quantity, className = _a.className, _b = _a.uiVersion, uiVersion = _b === void 0 ? 0 : _b, displayPeriod = _a.displayPeriod, displayVat = _a.displayVat, displayDisclaimer = _a.displayDisclaimer, overrideSales = _a.overrideSales, setIsDiscounted = _a.setIsDiscounted;
    var _c = usePrice(productIdentifier, quantity), price = _c.data, isLoading = _c.loading;
    return (React.createElement(Pricing, { containerTag: containerTag, priceTag: priceTag, priceTextSize: priceTextSize, priceTextWeight: priceTextWeight, discountTextSize: discountTextSize, discountTextWeight: discountTextWeight, discountAligned: discountAligned, isLoading: isLoading, price: price, displayPeriodKey: displayPeriodKey, className: className, uiVersion: uiVersion, displayPeriod: displayPeriod, displayVat: displayVat, displayDisclaimer: displayDisclaimer, overrideSales: overrideSales, setIsDiscounted: setIsDiscounted }));
};

var defaultConfig = {
    wranglerApi: {
        baseUrl: 'https://wrangler.prod.merch.vpsvc.com',
        operations: {
            getWranglerPrice: {
                timeoutMS: 3 * 1000,
                cache: {
                    maxAgeMS: 60 * 1000,
                    maxSize: 10,
                },
                retry: {
                    policy: RetryPolicy.LinearBackOff,
                    count: 1,
                },
                parameters: {
                    requestor: 'Digital Merchandising',
                    merchantId: 'Vistaprint',
                },
            },
        },
    },
};

function getWranglerApiRequestParameters(pricingContext, connection, merchandisingExperience, responseComponents) {
    var params = {
        pricingContextString: pricingContext.contextAsQueryString,
        'selectedAttributes[Connection]': connection,
        includeVat: pricingContext.isVatInclusive,
        merchandisingExperience: merchandisingExperience,
        responseComponents: responseComponents,
    };
    return params;
}
var transformWranglerApiResponseData = function (isVatInclusive, countryCode, response) {
    var _a, _b, _c;
    var wranglerPriceData = (_a = response.standardConfigurator) === null || _a === void 0 ? void 0 : _a.price;
    var wranglerMetadata = response.standardConfigurator;
    var priceInfo = {
        quantities: ((_c = (_b = wranglerMetadata === null || wranglerMetadata === void 0 ? void 0 : wranglerMetadata.quantities) === null || _b === void 0 ? void 0 : _b.quantities) !== null && _c !== void 0 ? _c : []).map(function (q) { return ({
            quantity: parseInt(q.quantity),
            culture: countryCode,
            currency: wranglerPriceData === null || wranglerPriceData === void 0 ? void 0 : wranglerPriceData.currency,
            listPrice: q.totalListPrice,
            discountPrice: q.totalDiscountedPrice,
            unitListPrice: q.unitListPrice,
            unitDiscountPrice: q.unitDiscountedPrice,
            badges: q.badges,
            vatInc: isVatInclusive,
            minimumFractionDigits: wranglerPriceData === null || wranglerPriceData === void 0 ? void 0 : wranglerPriceData.fractionDigits,
            hideVatMessage: false,
        }); }),
        culture: countryCode,
        currency: wranglerPriceData === null || wranglerPriceData === void 0 ? void 0 : wranglerPriceData.currency,
        vatInc: isVatInclusive !== null && isVatInclusive !== void 0 ? isVatInclusive : false,
        minimumFractionDigits: wranglerPriceData === null || wranglerPriceData === void 0 ? void 0 : wranglerPriceData.fractionDigits,
        hideVatMessage: false,
    };
    return { priceInfo: priceInfo, wranglerMetadata: wranglerMetadata };
};

var VISTAPRINT_TENANT = 'vistaprint';
var MERCHANDISING_EXPERIENCE = 'Product Page';
var RESPONSE_COMPONENT = 'standardConfigurator';
var apiConfig = defaultConfig.wranglerApi;
var opConfig = apiConfig.operations.getWranglerPrice;
var wranglerClientDispenser = new HttpClientDispenser(apiConfig, opConfig);
var wranglerHookDispenser = new Dispenser(function () {
    return makeUseAxios({
        axios: wranglerClientDispenser.getInstance(),
        defaultOptions: { manual: true },
    });
});
function useWranglerPrice(productKey, productVersion, connection) {
    var pricingContext = usePricingContext();
    var countryCode = useLocale().identifier;
    var _a = wranglerHookDispenser.getInstance()({}), responseValues = _a[0], fetchPrice = _a[1];
    useEffect(function () {
        if (isSome(pricingContext)) {
            var params = getWranglerApiRequestParameters(pricingContext.value, connection, MERCHANDISING_EXPERIENCE, RESPONSE_COMPONENT);
            var transformResponse = function (data) {
                if (!data)
                    return;
                return transformWranglerApiResponseData(pricingContext.value.isVatInclusive, countryCode, data);
            };
            var newTransformers = []
                .concat(wranglerClientDispenser.getInstance().defaults.transformResponse)
                .concat(transformResponse);
            var axiosConfig = {
                url: "/api/v1/".concat(VISTAPRINT_TENANT, "/").concat(countryCode, "/configuratorData/").concat(productKey, "/").concat(productVersion),
                method: 'get',
                params: params,
                transformResponse: newTransformers,
            };
            fetchPrice(axiosConfig);
        }
    }, [
        connection,
        countryCode,
        fetchPrice,
        pricingContext,
        productKey,
        productVersion,
    ]);
    return responseValues;
}

export { BillingPeriodKeys, Disclaimer, DisclaimerContainer, DisclaimerWithPrice, DisclaimerWithPriceContainer, DisclaimerWithSaveAmount, DisclaimerWithSaveAmountContainer, Price, PriceContainer, Pricing, PricingContainer, PricingContentProvider, PricingContextProvider, PromotionalDisclaimer, Vat, formatPrice, getLocaleBillingPeriods, getLocaleBillingPeriodsContentful, useBillingPeriodContent, useDisplayContent, useDisplayPrice, useDisplayPriceContent, usePrice, usePricingContext, usePromotionalDisclaimerContent, useWranglerPrice };
